"use client";

import { createContext, useEffect, useRef, useState, type Dispatch, type SetStateAction, type ReactNode } from "react";
import { useRouter } from "next/navigation";

export const RegistrationDialogReadiness = createContext<Dispatch<SetStateAction<boolean>> | null>(null);

export function RegistrationDialog({ children, label = "注册并入驻 Mirafans 镜界", waitForRegistration = false }: { children: ReactNode; label?: string; waitForRegistration?: boolean }) {
  const [contentReady, setContentReady] = useState(false);
  const visible = !waitForRegistration || contentReady;
  const dialog = useRef<HTMLDialogElement>(null);
  const router = useRouter();
  useEffect(() => {
    if (!visible) return;
    const element = dialog.current;
    const overflow = document.body.style.overflow;
    element?.showModal();
    document.body.style.overflow = "hidden";
    return () => { element?.close(); document.body.style.overflow = overflow; };
  }, [visible]);
  return <RegistrationDialogReadiness.Provider value={setContentReady}><dialog ref={dialog} autoFocus className="onboarding-ui auth-registration-dialog" aria-label={label} onCancel={event => { event.preventDefault(); router.push("/", { scroll: false }); }}>{children}</dialog></RegistrationDialogReadiness.Provider>;
}
